
import axios from 'axios';
import config from '../config/config';
import { getAuthToken } from '../utils/token';

const getHeaders = () => ({
    Authorization: `Bearer ${getAuthToken()}`,
    Accept: 'application/json',
});

const getJsonHeaders = () => ({
    ...getHeaders(),
    'Content-Type': 'application/json',
});

// Existing production log approval services
export const getProductionLogs = async (params = {}) => {
    const response = await axios.get(
        `${config.API}/dispatch/indexApproval`,
        {
            params,
            headers: getHeaders(),
        }
    );

    return response.data;
};

export const saveProductionLogApproval = async (payload) => {
    const response = await axios.post(
        `${config.API}/dispatch/saveapproval`,
        payload,
        {
            headers: getJsonHeaders(),
        }
    );

    return response.data;
};

// Dispatch CRUD services

// GET: /api/dispatch/index
export const getDispatches = async (params = {}) => {
    const response = await axios.get(
        `${config.API}/dispatch/index`,
        {
            params,
            headers: getHeaders(),
        }
    );

    return response.data;
};

// GET: /api/dispatch/getPurchaseOrderList
export const getDispatchPurchaseOrders = async (params = {}) => {
    const response = await axios.get(
        `${config.API}/dispatch/getPurchaseOrderList`,
        {
            params,
            headers: getHeaders(),
        }
    );

    return response.data;
};

// POST: /api/dispatch/create
export const createDispatch = async (payload) => {
    const response = await axios.post(
        `${config.API}/dispatch/create`,
        payload,
        {
            headers: getJsonHeaders(),
        }
    );

    return response.data;
};



// DELETE: /api/dispatch/delete/{id}
export const deleteDispatch = async (id) => {
    const response = await axios.delete(
        `${config.API}/dispatch/delete/${id}`,
        {
            headers: getHeaders(),
        }
    );

    return response.data;
};

// PUT: /api/dispatch/update/{id}
// Use this only after registering the matching Laravel PUT route.
export const updateDispatch = async (id, payload) => {
    const response = await axios.put(
        `${config.API}/dispatch/update/${id}`,
        payload,
        {
            headers: getJsonHeaders(),
        }
    );

    return response.data;
};